module.exports = __webpack_public_path__ + "img/teamwork.8c8fc13a.svg";